// extracted by css-extract-rspack-plugin
export default {"QueryBuilderBackButton":"A1ll4"};